export default "__VITE_ASSET__1b8eb016__"